/* REDRUM market persistence and EU localization safeguards. */
(function () {
  'use strict';

  var context = window.RedrumMarketContext || {};
  var countryStorageKey = 'redrum_market_country';
  var localeStorageKey = 'redrum_market_locale';

  function validCountry(value) {
    return /^[A-Z]{2}$/.test(value || '');
  }

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function selectedCountry() {
    var queryCountry = (new URLSearchParams(window.location.search).get('country') || '').toUpperCase();
    var storedCountry = (readSession(countryStorageKey) || '').toUpperCase();
    var renderedCountry = (context.country || '').toUpperCase();
    var country = queryCountry || storedCountry || renderedCountry || 'US';

    if (validCountry(country)) {
      writeSession(countryStorageKey, country);
      context.selectedCountry = country;
      return country;
    }

    return 'US';
  }

  function localUrl(rawUrl, country) {
    if (!rawUrl || !validCountry(country)) return rawUrl;
    if (/^(#|mailto:|tel:|javascript:)/i.test(rawUrl)) return rawUrl;

    var url;
    try {
      url = new URL(rawUrl, window.location.origin);
    } catch (error) {
      return rawUrl;
    }

    if (url.origin !== window.location.origin || url.pathname.indexOf('/localization') !== -1) {
      return rawUrl;
    }

    url.searchParams.set('country', country);
    return url.pathname + url.search + url.hash;
  }

  function updateThemeRoutes(country) {
    if (!window.theme || !window.theme.routes) return;

    [
      'cart_url',
      'cart_add_url',
      'cart_change_url',
      'cart_update_url',
      'cart_clear_url'
    ].forEach(function (key) {
      if (window.theme.routes[key]) {
        window.theme.routes[key] = localUrl(window.theme.routes[key], country);
      }
    });
  }

  function decorateNode(root, country) {
    var scope = root && root.querySelectorAll ? root : document;

    function decorateLink(link) {
      var localized = localUrl(link.getAttribute('href'), country);
      if (localized) link.setAttribute('href', localized);
    }

    function decorateForm(form) {
      if (form.action.indexOf('/localization') !== -1) return;
      var localized = localUrl(form.getAttribute('action'), country);
      if (localized) form.setAttribute('action', localized);
    }

    if (scope.matches && scope.matches('a[href]')) decorateLink(scope);
    if (scope.matches && scope.matches('form[action]')) decorateForm(scope);

    scope.querySelectorAll('a[href]').forEach(function (link) {
      decorateLink(link);
    });

    scope.querySelectorAll('form[action]').forEach(function (form) {
      decorateForm(form);
    });
  }

  function rememberLocalizationChoice(event) {
    var option = event.target.closest('form[action*="/localization"] [data-popout-option]');
    if (!option) return;

    var popout = option.closest('popout-select');
    var input = popout && popout.querySelector('[data-popout-input]');
    var value = option.getAttribute('data-value') || '';
    if (!input || !value) return;

    if (input.name === 'country_code') {
      value = value.toUpperCase();
      if (validCountry(value)) {
        writeSession(countryStorageKey, value);
        context.selectedCountry = value;
      }
    }

    if (input.name === 'locale_code') {
      writeSession(localeStorageKey, value.toLowerCase());
    }
  }

  function replaceExactText(root, replacements) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var trimmed = node.nodeValue.trim();
      if (Object.prototype.hasOwnProperty.call(replacements, trimmed)) {
        node.nodeValue = node.nodeValue.replace(trimmed, replacements[trimmed]);
      }
    }
  }

  function completeGermanInterface(root) {
    if ((context.locale || '').toLowerCase() !== 'de') return;

    replaceExactText(root || document.body, {
      'Small': 'Klein',
      'True to size': 'Fällt normal aus',
      'Large': 'Groß',
      'SHIPPING': 'VERSAND',
      'Join CLUBRED for discounts, early access drops and more.': 'Tritt CLUBRED bei und erhalte Rabatte, frühen Zugang zu neuen Releases und mehr.',
      'JOIN': 'BEITRETEN',
      'CONTACT': 'KONTAKT',
      'Powered by Shopify': 'Onlineshop von Shopify'
    });
  }

  var country = selectedCountry();
  updateThemeRoutes(country);

  document.addEventListener('click', rememberLocalizationChoice, true);

  function initialize() {
    decorateNode(document, country);
    completeGermanInterface(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          decorateNode(node, country);
          completeGermanInterface(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
